import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledThirdPartySolidCross = styled.svg.withConfig({
  displayName: "SolidCrossIcon__StyledThirdPartySolidCross",
  componentId: "sc-1c19qkn-0"
})(["width:14px;height:14px;position:absolute;top:0;right:0;transform:scale(1.8);"]);
export const SolidCrossIcon = ({
  title,
  color
}) => {
  return /*#__PURE__*/_jsxs(StyledThirdPartySolidCross, {
    viewBox: "0 0 32 32",
    "data-selenium-test": "window-closed-icon",
    children: [/*#__PURE__*/_jsx("title", {
      children: title
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 5L27 13",
      stroke: color,
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M27 5L19 13",
      stroke: color,
      strokeLinecap: "round"
    })]
  });
};